import React, { useState, useEffect } from 'react';
// import { Button } from './Button';
// import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  // const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <a target="_blank" rel="noopener noreferrer" href="https://itotem.azurewebsites.net/" className='navbar-logo' onClick={closeMobileMenu}>
            <img src="images/itotemlogo.png" alt="iTOTEM Logo"></img>
          </a>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          </ul>
            <img className='rightimg' src="images/itotemslogan.png" alt="iTOTEM Logo"></img>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
